import { render } from "./imagenSegunda.vue?vue&type=template&id=d3a22da4&scoped=true"
import script from "./imagenSegunda.vue?vue&type=script&lang=js"
export * from "./imagenSegunda.vue?vue&type=script&lang=js"

import "./imagenSegunda.vue?vue&type=style&index=0&id=d3a22da4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3a22da4"]])

export default __exports__